<template>
  <a-space>
    <template v-for="item in options">
      <template v-if="!item.show || item.show(record) !== false">
        <template v-if="item.type === 'update'">
          <a-tooltip :key="item.type" :title="item.label || '编辑'">
            <a-button
              class="iss-btn"
              shape="circle"
              :size="size"
              @click="handleClick(item)"
            >
              <template #icon>
                <component :is="icons[item.icon || 'EditTwoTone']" />
              </template>
            </a-button>
          </a-tooltip>
        </template>
        <template v-else-if="item.type === 'delete'">
          <a-popconfirm
            :key="item.type"
            title="确认删除该标签？"
            @confirm="handleClick(item)"
          >
            <a-tooltip :title="item.label || '删除'">
              <a-button class="btn-delete" shape="circle" :size="size">
                <template #icon>
                  <component
                    :is="icons[item.icon || 'DeleteTwoTone']"
                    twoToneColor="#f5222d"
                  />
                </template>
              </a-button>
            </a-tooltip>
          </a-popconfirm>
        </template>
        <template v-else>
          <a-tooltip :key="item.type" :title="item.label">
            <a-button
              class="iss-btn"
              shape="circle"
              :size="size"
              @click="handleClick(item)"
            >
              <template #icon>
                <component :is="icons[item.icon]" />
              </template>
            </a-button>
          </a-tooltip>
        </template>
      </template>
    </template>
  </a-space>
</template>

<script>
import { getCurrentInstance } from 'vue';
import { Divider, Popconfirm, Space, Tooltip } from 'ant-design-vue';
import * as icons from '@ant-design/icons-vue';

export default {
  name: 'Operation',
  components: {
    ADivider: Divider,
    APopconfirm: Popconfirm,
    ATooltip: Tooltip,
    ASpace: Space,
  },
  props: {
    options: Array,
    record: Object,
    size: {
      type: String,
      default: 'default',
    },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    return {
      icons,
      handleClick(item) {
        let permission = item.permission;
        typeof permission === 'function' && (permission = permission());
        typeof permission === 'string' && (permission = [permission]);
        proxy.$has(...permission).then(() => item.fnClick(props.record));
      },
    };
  },
};
</script>

<style lang="less" scoped>
.btn-delete {
  &:hover,
  &:focus {
    border-color: @red-5;
  }
  &:active {
    border-color: @red-6;
  }
}
.iss-btn {
  color: @primary-color;
}
</style>
